import { Modal, Text } from '@solvhealth/jigsaw-v1';
import React, { useState } from 'react';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { PaperworkFieldName } from '../../paperworkConstants';
import { AddressValidationCards } from './AddressValidationCards';
import { Address } from './types';
import { addAddressValidationLog } from '~/ducks/paperwork';

const StyledModalText = styled(Text).withConfig({ componentId: 'sc-1b9m5vy-0' })`
  padding: 24px 0 16px 0;
`;

export type AddressOption = 'validatedAddress' | 'submittingAddress';

export function SuggestedAddressModal({
  diffs,
  validatedAddress,
  form,
  open,
  onClose,
  onContinue,
}: {
  diffs: any;
  validatedAddress: Address;
  form: formShape;
  open: boolean;
  onClose: () => void;
  onContinue: (useValidatedAddress: boolean) => void;
}) {
  const [selectedAddressOption, setSelectedAddressOption] = useState(
    'validatedAddress' as AddressOption
  );

  const dispatch = useDispatch();

  return (
    <Modal
      alignment="left"
      description="We’re having trouble verifying the address you provided. Here’s our suggestion."
      hideCloseButton
      onClose={() => onClose()}
      open={open}
      primaryCta={{
        text: 'Confirm address',
        onClick: () => {
          /**
           * add fixed-typos address validation log
           * validation is successful if Mary selected the 'validatedAddress'
           * as opposed to sticking to the original address she entered
           */
          dispatch(
            addAddressValidationLog({
              correction_context: 'paperwork',
              correction_type: 'fixed-typos',
              validation_successful: selectedAddressOption === 'validatedAddress',
            })
          );
          if (selectedAddressOption === 'submittingAddress') {
            onContinue(false);
            return;
          }
          const { address1, address2, city, state, zip } = validatedAddress;
          form.setFields({
            [PaperworkFieldName.PATIENT_ADDRESS_STREET]: {
              value: address1,
              touched: true,
            },
            [PaperworkFieldName.PATIENT_ADDRESS_STREET_TWO]: {
              value: address2,
              touched: true,
            },
            [PaperworkFieldName.PATIENT_ADDRESS_CITY]: {
              value: city,
              touched: true,
            },
            [PaperworkFieldName.PATIENT_ADDRESS_STATE]: {
              value: state,
              touched: true,
            },
            [PaperworkFieldName.PATIENT_ADDRESS_ZIP]: {
              value: zip,
              touched: true,
            },
          });
          onContinue(true);
        },
      }}
      secondaryCta={{
        text: 'Go back to modify address',
        onClick: () => onClose(),
      }}
      title="Address verification"
      variant="short"
    >
      <StyledModalText textColor="gray-500">Please select an option below.</StyledModalText>
      <AddressValidationCards
        diffs={diffs}
        handleChange={setSelectedAddressOption}
        selectedAddressOption={selectedAddressOption}
      />
    </Modal>
  );
}
